<template>
	<div class="trip-offers">
		<div v-if="isLoading" class="loading-view">
			<i class="fa fa-spinner-third fa-spin fa-spin-fast"></i>
		</div>

		<ul v-if="!isLoading && offers.length > 0">
			<li v-for="(offer, index) in offers" v-bind:key="index">
				<slot v-bind:offer="offer"></slot>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	props: ['loadEndpoint'],
	data: function() {
		return {
			offers: [],
			isLoading: false,
			offset: 0,
		}
	},
	mounted: function() {
		this.load(false, true);
	},
	computed: {},
	methods: {
		load: function(reset = false, initial = false) {
			var params = this.$root.$refs.filterbar.buildParams();
			var self = this;

			//Reset
			if (reset === true) {
				this.offers = [];
				this.offset = 0;
			}

			//Activate loading state
			this.isLoading = true;

			params.pageOffset = this.offset;
			params.pageLimit = 20;

			//Make request
			axios.get(this.loadEndpoint, {
				params: params
			}).then(function (response) {
				//Push result to current dates set.
				Array.prototype.push.apply(self.offers, response.data.results.map(function(offer) {
					//Outbound flight
					offer.flight.outbound.period.departure = new Date(Date.parse(offer.flight.outbound.period.departure.substr(0,16)));
					offer.flight.outbound.period.arrival = new Date(Date.parse(offer.flight.outbound.period.arrival.substr(0,16)));

					//Inbound flight
					offer.flight.inbound.period.departure = new Date(Date.parse(offer.flight.inbound.period.departure.substr(0,16)));
					offer.flight.inbound.period.arrival = new Date(Date.parse(offer.flight.inbound.period.arrival.substr(0,16)));

					//Arrival date
					offer.arrivalDate = new Date(Date.parse(offer.arrivalDate));

					return offer;
				}));

				//Deactive loading state
				self.isLoading = false;

				//Force update
				self.$forceUpdate();

				//Scroll top
				if (!initial) {
					$('html,body').stop().animate({
						scrollTop: $('div.trip-offers').offset().top - 70
					}, 1000);
				}
			}).catch(function (error) {
				console.error(error);
				alert('Error. Please check the console.');
			});
		},
		checkLoad: function() {
			
		}
	}
}
</script>